import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR_VACANTE } from "../../utils/uiText";

//------------- STATE -------------------------
const initialState = {
  //
  vacantes: [],
  vacantesoples: [],
  messageError: "",
  loading: false,

  //Datos vacante
  idSistema: null,
  idConcurso: null,
  idConvocatoria: null,
  nombreConcurso: null,
  nombreConvocatoria: null,
  vacanteDetalle: {},
  listaVacantes: [],
};

//
const GET_VACANTE = "GET_VACANTE";
const GET_VACANTE_CLEAN = "GET_VACANTE_CLEAN";
const GET_VACANTE_ERROR = "GET_VACANTE_ERROR";
const GET_VACANTE_ERROR_SERVICE = "GET_VACANTE_ERROR_SERVICE";
const LOADING_VACANTE = "LOADING_VACANTE";

const GET_VACANTEOPLE = "GET_VACANTEOPLE";
const GET_VACANTEOPLE_CLEAN = "GET_VACANTEOPLE_CLEAN";
const GET_VACANTEOPLE_ERROR = "GET_VACANTEOPLE_ERROR";
const GET_VACANTEOPLE_ERROR_SERVICE = "GET_VACANTEOPLE_ERROR_SERVICE";
const LOADING_VACANTEOPLE = "LOADING_VACANTE_OPLE";

const ASIGNAR_SISTEMA = "ASIGNAR_SISTEMA";
const ASIGNAR_CONCURSO = "ASIGNAR_CONCURSO";
const ASIGNAR_CONVOCATORIA = "ASIGNAR_CONVOCATORIA";
const NOMBRE_CONCURSO = "NOMBRE_CONCURSO";
const NOMBRE_CONVOCATORIA = "NOMBRE_CONVOCATORIA";
const ASIGNAR_VACANTE_DETALLE = "ASIGNAR_VACANTE_DETALLE";
const REINICIAR_DATOS = "REINICIAR_DATOS";
const LISTA_VACANTES = "LISTA_VACANTES";

//------------- REDUCER -----------------------------------------------------
const consultaVacanteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VACANTE:
      return {
        ...state,
        vacantes: [...action.payload],
        listaVacantes: action.payload,
        messageError: null,
      };
    case GET_VACANTE_ERROR:
      return {
        ...state,
        messageError: ERROR_VACANTE,
        vacantes: [],
        loading: false,
      };
    case GET_VACANTE_ERROR_SERVICE:
      return {
        ...state,
        vacantes: [],
        loading: false,
        messageError: ERROR_VACANTE,
      };
    case GET_VACANTE_CLEAN:
      return initialState;
    case LOADING_VACANTE:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_VACANTEOPLE:
      return {
        ...state,
        vacantesoples: [...action.payload],
        listaVacantes: action.payload,
        messageError: null,
      };
    case GET_VACANTEOPLE_ERROR:
      return {
        ...state,
        messageError: ERROR_VACANTE,
        vacantesoples: [],
        loading: false,
      };
    case GET_VACANTEOPLE_ERROR_SERVICE:
      return {
        ...state,
        vacantesoples: [],
        loading: false,
        messageError: ERROR_VACANTE,
      };
    case GET_VACANTEOPLE_CLEAN:
      return initialState;
    case LOADING_VACANTEOPLE:
      return {
        ...state,
        loading: action.payload,
      };
    case LISTA_VACANTES:
      return {
        ...state,
        listaVacantes: action.payload,
      };

    case ASIGNAR_SISTEMA:
      return {
        ...state,
        idSistema: action.payload,
      };

    case ASIGNAR_CONCURSO:
      return {
        ...state,
        idConcurso: action.payload,
      };

    case ASIGNAR_CONVOCATORIA:
      return {
        ...state,
        idConvocatoria: action.payload,
      };

    case NOMBRE_CONCURSO:
      return {
        ...state,
        nombreConcurso: action.payload,
      };

    case NOMBRE_CONVOCATORIA:
      return {
        ...state,
        nombreConvocatoria: action.payload,
      };

    case ASIGNAR_VACANTE_DETALLE:
      return {
        ...state,
        vacanteDetalle: { ...action.payload },
      };
    case REINICIAR_DATOS:
      return {
        ...state,

        vacanteDetalle: {},
        listaVacantes: [],
      };
    default:
      return state;
  }
};
export default consultaVacanteReducer;

const setLoading = (status) => ({
  type: LOADING_VACANTE,
  payload: status,
});

const setLoadingOPLE = (status) => ({
  type: LOADING_VACANTEOPLE,
  payload: status,
});

export const cleanVacante = () => (dispatch) => {
  dispatch({
    type: GET_VACANTE_CLEAN,
  });
};

export const cleanVacanteOPLE = () => (dispatch) => {
  dispatch({
    type: GET_VACANTEOPLE_CLEAN,
  });
};

export const asignarListaVacantes = (lista) => async (dispatch) => {
  dispatch({
    type: LISTA_VACANTES,
    payload: lista,
  });
};

export const asignarSistema = (idSistema) => async (dispatch) => {
  dispatch({
    type: ASIGNAR_SISTEMA,
    payload: idSistema,
  });
};

export const asignarConcurso = (idConcurso) => async (dispatch) => {
  dispatch({
    type: ASIGNAR_CONCURSO,
    payload: idConcurso,
  });
};

export const asignarConvocatoria = (idConvocatoria) => async (dispatch) => {
  dispatch({
    type: ASIGNAR_CONVOCATORIA,
    payload: idConvocatoria,
  });
};

export const nameConcurso = (nombreConcurso) => async (dispatch) => {
  dispatch({
    type: NOMBRE_CONCURSO,
    payload: nombreConcurso,
  });
};

export const nameConvocatoria = (nombreConvocatoria) => async (dispatch) => {
  dispatch({
    type: NOMBRE_CONVOCATORIA,
    payload: nombreConvocatoria,
  });
};

export const asignarVacante = (vacanteDetalle) => async (dispatch) => {
  dispatch({
    type: ASIGNAR_VACANTE_DETALLE,
    payload: vacanteDetalle,
  });
};

export const limpiarDatos = () => async (dispatch) => {
  dispatch({
    type: REINICIAR_DATOS,
  });
};

export const getVacantes = (idConcurso, idConvocatoria) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerVacantes}`,

      { idConcurso, idConvocatoria },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: GET_VACANTE,
      payload: response.data,
    });
    dispatch(setLoading(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_VACANTE_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_VACANTE_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getVacantesOples =
  (idConcurso, idConvocatoria, idEstado) => async (dispatch) => {
    try {
      const urls = await axios(window.location.origin + JSON_URL);
      const response = await axios.post(
        `${urls.data.urlServer}${urls.data.urlObtenerVacantesOPLES}`,

        { idConcurso, idConvocatoria, idEstado },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({
        type: GET_VACANTEOPLE,
        payload: response.data,
      });
      dispatch(setLoadingOPLE(false));
    } catch (error) {
      if (!error.response) {
        dispatch({
          type: GET_VACANTEOPLE_ERROR_SERVICE,
        });
      } else {
        dispatch({
          type: GET_VACANTEOPLE_ERROR,
          payload: error.response.data,
        });
      }
    }
  };
